<atlas-top-bar
  [hideCenters]="hideCenters()"
  [hideLanguageSelector]="hideLanguageSelector()"
  [hideNotifications]="hideNotifications()"
  [hideUserDropdown]="disableUserDropdown()"
  [dropdownItems]="dropdownItems()"
  [hideBottomBorder]="hideBottomBorder()"
>
  <ng-content></ng-content>
</atlas-top-bar>
